import { ShieldCheck, Check } from "lucide-react";
import { Reveal } from "./Reveal";

const FEATURES = [
  "Transit insurance for all goods in motion",
  "Public & product liability coverage",
  "Professional, trained & vetted movers",
];

export const Insurance = () => (
  <section id="insurance" className="relative" data-testid="insurance-section">
    <div className="mx-auto max-w-7xl px-5 py-10 lg:px-10">
      <Reveal>
        <div className="rounded-2xl border border-sky-100 bg-sky-50/80 p-10 shadow-sm md:p-16">
          <div className="flex flex-col items-start gap-8 md:flex-row md:items-center md:gap-14">
            <div className="flex h-20 w-20 shrink-0 items-center justify-center rounded-2xl bg-white shadow-sm md:h-24 md:w-24">
              <ShieldCheck className="h-10 w-10 text-blue-600 md:h-12 md:w-12" strokeWidth={1.8} />
            </div>
            <div className="flex-1">
              <p className="mb-3 text-xs font-bold uppercase tracking-[0.3em] text-blue-600">Peace of mind</p>
              <h2 className="font-display text-2xl font-bold tracking-tight text-slate-900 md:text-4xl" data-testid="insurance-headline">
                Fully Insured Moving Services
              </h2>
              <p className="mt-3 max-w-xl text-base leading-relaxed text-slate-600 md:text-lg">
                Your belongings and our moving operations are covered by insurance.
              </p>
              <p
                className="mt-6 inline-flex items-center gap-2 rounded-lg border border-sky-200 bg-white px-5 py-2.5 font-mono text-sm font-bold tracking-wide text-sky-900 shadow-sm"
                data-testid="insurance-policy-no"
              >
                Policy No: BIZ158027BUS
              </p>
            </div>
          </div>
          <ul className="mt-10 grid gap-4 border-t border-sky-100 pt-10 sm:grid-cols-3">
            {FEATURES.map((f) => (
              <li key={f} className="flex items-center gap-3 text-sm font-medium text-slate-700" data-testid={`insurance-feature-${f.slice(0, 12).toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-blue-600">
                  <Check className="h-3.5 w-3.5 text-white" strokeWidth={3} />
                </span>
                {f}
              </li>
            ))}
          </ul>
        </div>
      </Reveal>
    </div>
  </section>
);
